import React, { useState, useEffect } from 'react';
import './Projects.css';
import en from '../../../language/en/Projects.json';
import es from '../../../language/es/Projects.json';
import { Link } from 'react-router-dom';
import { Transition } from 'react-spring/renderprops';
import config from '../../../config/config.json';
import { Paper, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';
import { Container, Table } from 'react-bootstrap';
import ZoomInIcon from '@material-ui/icons/ZoomIn';

const Projects = ({ lang }) => {
	window.scrollTo(0, 1);

	const [projects, setProjects] = useState([]);

	const url = `${config.apiBaseUrl}/proyectos`;
	async function fetchData() {
		const response = await fetch(url);
		const data = await response.json();
		setProjects(data);
	}

	useEffect(() => {
		fetchData();
	}, [url]);

	const selectedLanguage = (lang === 'en') ? en : es;

	const Projects = projects.map((project, i) => {

		return (
			<tr key={i}>
				<td>{project.id}</td>
				<td>{project.nombre}</td>
				<td>{project.apellidos}</td>
				<td>{project.ci}</td>
				<td>{project.plaza}</td>
				<td>{project.departamento}</td>
				<td>{project.estado}</td>
				<td>
					<Link className="btn btn-sm blue" to={'/investigation/project/' + project.id}>
						<i className="fa fa-search-plus"></i>
						Ver
					</Link>
				</td>
			</tr>
		)
	});

	return (
		<main className="Projects">
			<Container>
				<div className="heading">
					<Typography variant="h4" color="initial" className="efecto-espejo">Proyectos</Typography>
				</div>
				<TableContainer>
					<Table sx={{ minWidth: 650 }} aria-label="simple table">
						<TableHead>
							<TableRow>
								<TableCell>No</TableCell>
								<TableCell align="center">Título</TableCell>
								{/* <TableCell>Programa</TableCell> */}
								{/* <TableCell>Entidad Principal</TableCell> */}
								<TableCell>Jefe</TableCell>
								<TableCell>Inicia</TableCell>
								<TableCell>Culmina</TableCell>
								<TableCell>Acción</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{
								projects.map((project, index) => (
									<TableRow key={project.id}>
										<TableCell>{index + 1}</TableCell>
										<TableCell>{project.titulo}</TableCell>
										{/* <TableCell>{project.programa}</TableCell> */}
										{/* <TableCell>{project.entidad_principal}</TableCell> */}
										<TableCell>{project.jefe}</TableCell>
										<TableCell>{project.fecha_inicio.split('-').reverse().join('/')}</TableCell>
										<TableCell>{project.fecha_fin.split('-').reverse().join('/')}</TableCell>
										<TableCell align="right">
											<Link to={'/investigation/project/' + project.id}>
												<ZoomInIcon />
											</Link>
										</TableCell>
									</TableRow>
								))
							}
						</TableBody>
					</Table>
				</TableContainer>
			</Container>
		</main>
	)
}

export default Projects;